import jwt_decode from "jwt-decode";

export const getAuthData = () => {
    const token = localStorage.getItem("token");
    
    if (!token) return null;

    try {
        const decoded = jwt_decode(token);
        
        // Kthejmë një objekt me të gjitha të dhënat që na duhen
        return {
            companyUnitId: decoded["CompanyUnitID"],
            companyId: decoded["CompanyId"],
            email: decoded["email"] || decoded["sub"],
            role: decoded["role"]
        };
    } catch (error) {
        console.error("Token i pavlefshëm:", error);
        return null;
    }
};
